import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Chips from 'components/field/Chips';
import EnumSelect from 'components/field/EnumSelect';
import IntegerInput from 'components/field/IntegerInput';
import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';

import { ENUMS } from 'services/consts';

import DefaultWarehouseField from './Fields/DefaultWarehouseField';
import OrderPrefix from './Fields/OrderPrefix';
import StoreCredentials from './Fields/StoreCredentials';
import * as S from './SalesChannel.styled';

const AdvanceSettings = ({ children, developerSettings, enumName, fields = [] }) => {
	const {
		watch,
		setValue,
		formState: { isSubmitting, isLoading: isFormLoading }
	} = useFormContext();
	const { t } = useTranslation();
	const isLoading = isSubmitting || isFormLoading;
	const { salesChannel } = useSelector((state) => state.salesChannel);
	return (
		<S.StoreAccordion header={developerSettings ? 'developerSettings' : 'advancedSettings'}>
			{children}
			{fields.includes('addHour') && (
				<FormItem label="addHour" isLoading={isLoading}>
					<IntegerInput
						name="addHour"
						unit="hrs"
						placeholder={t('fieldPlaceholder', { name: t(`addHour`) })}
					/>
				</FormItem>
			)}
			{fields.includes('codString') && (
				<FormItem label="codString" isLoading={isLoading}>
					<StringInput name="codString" placeholder={t('fieldPlaceholder', { name: t(`codString`) })} />
				</FormItem>
			)}
			{fields.includes('commentKeys') && (
				<FormItem label="filterByTag" isLoading={isLoading}>
					<StringInput name="commentKeys" placeholder={t('fieldPlaceholder', { name: t(`commentKeys`) })} />
				</FormItem>
			)}
			{fields.includes('TrackingUrlType') && (
				<FormItem label="trackingUrlType" isLoading={isLoading}>
					<EnumSelect
						searchable={false}
						name="TrackingUrlType"
						enumName={ENUMS.TRACKING_URL_TYPE}
						setValue={(value) => {
							setValue(`TrackingUrlType`, value, { shouldValidate: true, shouldDirty: true });
						}}
						value={watch(`TrackingUrlType`)}
						placeholder={t('fieldPlaceholder', { name: t(`TrackingUrlType`) })}
					/>
				</FormItem>
			)}
			{fields.includes('statuses') &&
				(enumName ? (
					<FormItem
						label={salesChannel?.slug === 'salla' ? 'salla.filterByStatuses' : 'filterByStatuses'}
						isLoading={isLoading}>
						<EnumSelect
							searchable={false}
							name="statuses"
							multipleSelection
							enumName={enumName}
							setValue={(value) => {
								setValue(`statuses`, value, { shouldValidate: true, shouldDirty: true });
							}}
							value={watch(`statuses`)}
							placeholder={t('fieldPlaceholder', { name: t(`filterByStatuses`) })}
						/>
					</FormItem>
				) : (
					<FormItem label="filterByStatuses" isLoading={isLoading}>
						<Chips
							name="statuses"
							value={watch('statuses')}
							setValue={(value) => {
								setValue(`statuses`, value ?? null, { shouldValidate: true, shouldDirty: true });
							}}
							placeholder={t('fieldPlaceholder', { name: t(`filterByStatuses`) })}
						/>
					</FormItem>
				))}
			{fields.includes('ignoreNonCodOnPending') && (
				<FormItem label="ignoreNonCodOnPending" isLoading={isLoading} toolTip="ignoreNonCodOnPending.tooltip">
					<StringInput
						name="ignoreNonCodOnPending"
						placeholder={t('fieldPlaceholder', { name: t(`ignoreNonCodOnPending`) })}
					/>
				</FormItem>
			)}
			{fields.includes('prefix') && <OrderPrefix isLoading={isLoading} />}
			{fields.includes('password') && fields.includes('username') && <StoreCredentials required={false} />}
			{fields.includes('defaultWarehouse') && <DefaultWarehouseField isLoading={isLoading} />}
		</S.StoreAccordion>
	);
};

export default AdvanceSettings;
